const models = {
	'App\\Model\\Address': {
		name: 'Adresse | Adressen',
		icon: '@:entity.address.icon',
		noun: 'Die',
		header: 'street',
		filter: true,
	},
	'App\\Model\\Accounts\\Accounts': {
		name: 'Konto | Konten',
		icon: 'fal fa-box-dollar',
		noun: 'Das',
	},
	'App\\Model\\Accounts\\Journals': {
		name: 'Buchung | Buchungen',
		icon: 'fas fa-abacus',
		noun: 'Die',
	},
	'App\\Model\\Invoices': {
		name: 'Rechnung | Rechnungen',
		icon: 'fal fa-file-invoice',
		noun: 'Die',
	},
	'App\\Model\\Reports\\Report': {
		name: 'Meldung | Meldungen',
		icon: '@:entity.report.icon',
		noun: 'Die',
	},
	'App\\Model\\Cis\\Cis': {
		name: 'Z.I.S. Notiz | Z.I.S. Notizen',
		icon: 'fa-fw fa-solid fa-comment-lines',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CisType': {
		name: 'Z.I.S. Notiz Art | Z.I.S. Notizen Arten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Cis\\CisRecord': {
		name: 'Z.I.S. Notiz | Z.I.S. Notizen',
		icon: 'fa-fw fa-solid fa-comment-lines',
		noun: 'Die',
		target: 'einer Akte',
		header: 'id',
	},
	'App\\Model\\Comments': {
		name: 'Kommentar | Kommentare',
		icon: 'fa-regular fa-comment',
		noun: 'Der',
	},
	'App\\Model\\CraftsmanTask': {
		name: 'Handwerkerauftrag | Handwerkeraufträge',
		icon: 'fa-fw fas fa-toolbox',
		noun: 'Der',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskBuilding': {
		name: 'Liegenschaft | Liegenschaften',
		icon: 'fas fa-building',
		noun: 'Die',
		target: 'einem Handwerkerauftrag',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskPersons': {
		name: 'Kontakt | Kontakte',
		icon: 'fa-fw far fa-address-book',
		noun: 'Der',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskPersonTypes': {
		name: 'Handwerkerauftrag Kontakt Art | Handwerkerauftrag Kontakt Arten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskPersonContact': {
		name: 'Handwerkerauftrag Kontakt Person | Handwerkerauftrag Kontakt Personen',
		icon: 'fa-fw far fa-address-book',
		noun: 'Die',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskProcess': {
		name: 'Handwerkerauftrag Vorgang | Handwerkerauftrag Vorgänge',
		icon: 'fa-fw fal fa-cabinet-filing',
		noun: 'Der',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskRecord': {
		name: 'Akte | Akten',
		icon: 'fa-fw fas fa-toolbox',
		noun: 'Die',
		target: 'einem Handwerkerauftrag',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskStatus': {
		name: 'Handwerkerauftrag Status | Handwerkerauftrag Status',
		icon: 'fa-fw fal fa-tasks-alt',
		noun: 'Der',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskStatusText': {
		name: 'Status Text | Status Text',
		icon: 'fa-fw fal fa-info-square',
		noun: 'Der',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskType': {
		name: 'Handwerkerauftrag Art | Handwerkerauftrag Arten',
		icon: 'fa-fw fal fa-tags',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskUnit': {
		name: 'Einheit | Einheiten',
		icon: 'fa-fw far fa-address-book',
		noun: 'Die',
		target: 'einem Handwerkerauftrag',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskCis': {
		name: 'Z.I.S. Notiz | Z.I.S. Notizen',
		icon: 'fa-fw fa-solid fa-comment-lines',
		noun: 'Die',
		target: 'einem Handwerkerauftrag',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskTask': {
		name: 'Wiedervorlage | Wiedervorlagen',
		icon: 'fa-fw fa-solid fa-clipboard-list-check',
		noun: 'Die',
		target: 'einem Handwerkerauftrag',
		header: 'id',
	},
	'App\\Model\\Document': {
		name: 'Datei | Dateien',
		icon: 'fa-fw fas fa-file',
		noun: 'Die',
		header: 'file_notes',
		link: {
			name: 'document',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\DocumentContainer': {
		name: 'Dokument | Dokumente',
		icon: 'far fa-book',
		noun: 'Das',
		header: 'comment',
		filter: true,
	},
	'App\\Model\\DocumentType': {
		name: 'Dokumententart | Dokumentenarten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'type_short',
		filter: true,
	},
	'App\\Model\\DocumentRecord': {
		name: 'Dokument | Dokumente',
		icon: 'fa-fw fas fa-file',
		noun: 'Das',
		target: 'einer Akte',
		header: 'id',
	},
	'App\\Model\\DocumentCraftsmanTask': {
		name: 'Dokument | Dokumente',
		icon: 'fa-fw fas fa-file',
		noun: 'Das',
		target: 'einem Handwerkerauftrag',
		header: 'id',
	},
	'App\\Model\\Building': {
		name: 'Liegenschaft | Liegenschaften',
		icon: 'fas fa-building',
		noun: 'Die',
		header: 'search',
		link: {
			name: 'building',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\BuildingType': {
		name: 'Liegenschaft Typ | Liegenschaft Typen',
		icon: 'fa-solid fa-tags',
		noun: 'Der',
		header: 'short',
		filter: true,
	},
	'App\\Model\\Persons': {
		name: 'Person | Personen',
		icon: 'fa-fw far fa-address-book',
		noun: 'Die',
		header: 'lastname',
		link: {
			name: 'person',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Notes': {
		name: 'Notiz | Notizen',
		icon: 'fa-fw fa-l fa-notes',
		noun: 'Die',
	},
	'App\\Model\\PersonEmail': {
		name: 'E-Mail Adresse | E-Mail Adressen',
		icon: 'fa-solid fa-envelope',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Roles': {
		name: 'Personenfunktionsart | Personenfunktionsarten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'name',
		link: {
			name: 'rolepermission',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Roles\\RolePermission': {
		name: 'Personenfunktion | Personenfunktionen',
		icon: 'fa-fw fas fa-user-friends',
		noun: 'Die',
		header: 'id',
		link: {
			name: 'person',
			params: [{ field: 'person.id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Phonenumber': {
		name: 'Telefonnummer | Telefonnummern',
		icon: 'fa-solid fa-phone',
		noun: 'Die',
		header: 'number',
		link: {
			name: 'person',
			params: [{ field: 'person.id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\DeviceType': {
		name: 'Zähler Geräte Art | Zähler Geräte Arten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'description',
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\Type': {
		name: 'Zähler Art | Zähler Arten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'description',
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\Manufacturer': {
		name: 'Zähler Hersteller',
		icon: 'fa-solid fa-industry',
		noun: 'Der',
		header: 'description',
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\Meter': {
		name: 'Zähler',
		icon: 'fas fa-tachometer-alt',
		noun: 'Der',
		header: 'hp_id',
		link: {
			name: 'meterDetails',
			params: [
				{ field: 'id', value: 'meterId' },
				{ field: 'building_id', value: 'id' },
			],
		},
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\MeterLevel': {
		name: 'Zähler Wert | Zähler Werte',
		icon: 'fas fa-tachometer-alt',
		noun: 'Der',
		header: 'value',
		link: {
			name: 'meterDetails',
			params: [
				{ field: 'meter.id', value: 'meterId' },
				{ field: 'meter.building_id', value: 'id' },
			],
		},
		filter: true,
	},
	'App\\Model\\Record': {
		name: 'Akte | Akten',
		icon: 'fas fa-folders',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\RecordBuilding': {
		name: 'Liegenschaft |Liegenschaften',
		icon: 'fas fa-building',
		noun: 'Die',
		target: 'einer Akte',
		header: 'id',
	},
	'App\\Model\\RecordRolePermission': {
		name: 'Person | Personen',
		icon: 'fa-solid fa-users',
		noun: 'Die',
		target: 'einer Akte',
		header: 'id',
	},
	'App\\Model\\RecordUnit': {
		name: 'Einheit | Einheiten',
		icon: 'fal fa-building',
		noun: 'Die',
		target: 'einer Akte',
		header: 'id',
	},
	'App\\Model\\RecordStatus': {
		name: 'Akten Status | Akten Status',
		icon: 'fal fa-tasks-alt',
		noun: 'Der',
		header: 'id',
	},
	'App\\Model\\Ticket': {
		name: 'Ticket | Tickets',
		icon: 'fas fa-ticket',
		noun: 'Das',
		header: 'id',
		filter: true,
	},
	'App\\Model\\TicketType': {
		name: 'Ticket Art | Ticket Arten',
		icon: 'fa-fw fal fa-tags',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\TicketRecord': {
		name: 'Akte | Akten',
		icon: 'fa-solid fa-folders',
		noun: 'Die',
		target: 'einem Ticket',
		header: 'id',
	},
	'App\\Model\\Tasks\\Task': {
		name: 'Wiedervorlage | Wiedervorlagen',
		icon: 'fa-fw fa-solid fa-clipboard-list-check',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Tasks\\TaskType': {
		name: 'Wiedervorlagen Art | Wiedervorlagen Arten',
		icon: 'fa-solid fa-tags',
		noun: 'Die',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Tasks\\TaskRecord': {
		name: 'Wiedervorlage | Wiedervorlagen',
		icon: 'fa-solid fa-clipboard-list-check',
		noun: 'Die',
		target: 'einer Akte',
		header: 'id',
	},
	'App\\Model\\Unit': {
		name: 'Einheit | Einheiten',
		icon: 'fa-fw fal fa-building',
		noun: 'Die',
		header: 'position',
		link: {
			name: 'unit',
			params: [
				{ field: 'id', value: 'unitId' },
				{ field: 'building_id', value: 'id' },
			],
		},
		filter: true,
	},
	'App\\Model\\Propertymanager': {
		name: 'Verwalter',
		icon: 'fa-solid fa-people-roof',
		noun: 'Der',
		header: 'hp_id',
		link: {
			name: 'person',
			params: [{ field: 'person.id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Team': {
		name: 'Teammitglied | Teammitglieder',
		icon: 'fa-fw fal fa-chalkboard-teacher',
		noun: 'Das',
		header: 'id',
		filter: true,
	},
}

export default models
